import * as Flex from "@twilio/flex-ui";
import { FlexActionEvent, FlexAction } from "../../../../types/feature-loader";
import { isColdTransferEnabled } from "../../config";
import { TransferActionPayload } from "../../types/ActionPayloads";

export const actionEvent = FlexActionEvent.before;
export const actionName = FlexAction.TransferTask;
// invoke the custom chatTransferTask action if a cbm task otherwise carry on
export const actionHook = function handleChatTransfer(flex: typeof Flex) {
  if (!isColdTransferEnabled()) return;

  flex.Actions.addListener(`${actionEvent}${actionName}`, (payload: TransferActionPayload, abortFunction: any) => {
    if (flex.TaskHelper.isCBMTask(payload.task)) {
      // native action handler would fail for chat task so abort the action
      abortFunction();
      // Execute Chat Transfer Task
      flex.Actions.invokeAction("ChatTransferTask", payload);
    }
  });
};
